import { gql } from '@apollo/client';

export const fetchPartnerAccountById = gql`
  query fetchPartnerAccountById($id: ID!) {
    partnerAccount(id: $id) {
      id
      internalUseLicense {
        currencyIsoCode
        currentBalance
        startingBalance
      }
    }
  }
`;
